import { createInertiaApp } from '@inertiajs/vue3';
import { MotionPlugin } from '@vueuse/motion';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { vMaska } from 'maska/vue';
import type { DefineComponent } from 'vue';
import { createApp, h } from 'vue';
import { ZiggyVue } from 'ziggy-js';
import '../css/app.css';
import { createYmaps } from 'vue-yandex-maps';

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';
const yandexApiKey = import.meta.env.VITE_YANDEX_API_KEY || '';

createInertiaApp({
  title: (title) => title || appName,
  resolve: (name) => resolvePageComponent(`./pages/${name}.vue`, import.meta.glob<DefineComponent>('./pages/**/*.vue')),
  setup({ el, App, props, plugin }) {
    createApp({ render: () => h(App, props) })
      .use(plugin)
      .use(ZiggyVue)
      .use(MotionPlugin)
      .use(createYmaps({ apikey: yandexApiKey }))
      .directive('maska', vMaska)
      .mount(el);
  },
  progress: {
    color: '#4B5563',
  },
}).then(() => {
  document?.getElementById('app')?.removeAttribute('data-page');
});
